import styled from 'styled-components';
import { ScrimWinLoseProps } from './index';

export const Card = styled.div`
  position: relative;
  width: 98%;
  background: rgba(55, 57, 66, 0.6);
  border-radius: 16px;
`;

export const HeaderCard = styled.div<ScrimWinLoseProps>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  /* padding: 10px 16px 12px; */

  position: relative;
  width: 63%;
  /* height: 28px; */
  background: ${props =>
    props.bg ?? 'linear-gradient(0deg, rgba(0, 120, 41, 0.3), rgba(0, 120, 41, 0.3))'};
  border-radius: 0px 0px 16px 16px;

  /* Inside Auto Layout */

  flex: none;
  order: 0;
  flex-grow: 0;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
`;

export const BorderDate = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 6px;

  position: relative;
  bottom: 70px;
  width: 51%;
  height: 25px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 6px;
  margin-left: auto;
  margin-right: auto;
`;
export const HeaderTitle = styled.p`
  position: relative;

  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 140%;
  text-align: center;
  color: #ddd8d8;
`;

export const TextTeam = styled.p`
  position: relative;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 140%;
  color: #ffffff;
  text-align: left;
  margin-left: 13px;
  width: 118px;
  height: 20px;
`;

export const TextTeam1 = styled.p`
  position: relative;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 140%;
  color: #ffffff;
  text-align: right;
  margin-left: auto;
  right : 12px;
  width: 118px;
  height: 20px;
`;
export const Score1 = styled.p`
  position: relative;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 140%;
  color: #ffffff;
  text-align: left;
  margin-left: 41px;
`;
export const Score2 = styled.p`
  position: relative;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 140%;
  color: #ffffff;
  text-align: right;
  margin-right: 41px;
`;

export const BorderVs = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px 6px;
  position: relative;
  width: 31px;
  height: 24px;
  bottom: 85px;
  background: rgba(213, 31, 64, 0.12);
  border-radius: 5px;
  margin-left: auto;
  margin-right: auto;
`;

export const ImageResult = styled.img`
  position: relative;
  display: block;
  width: 90%;
  height: 176px;
  bottom: 20px;
  margin-left: auto;
  margin-right: auto;
  background: url('https://1.bp.blogspot.com/-Lyq80CcDwnw/XO93aSYWiII/AAAAAAAAHVI/hPFcVsJTRMcD1jQWKsa-HpT4tha12wZCwCLcBGAs/w1200-h630-p-k-no-nu/1.%2Bmobile%2Blegends%2Bbattle%2Bresult%2Bexample.png')
    no-repeat;
  border-radius: 12px;
`;
